import { render, staticRenderFns } from "./ClassHeader.vue?vue&type=template&id=19106c10&scoped=true"
import script from "./ClassHeader.vue?vue&type=script&lang=js"
export * from "./ClassHeader.vue?vue&type=script&lang=js"
import style0 from "./ClassHeader.vue?vue&type=style&index=0&id=19106c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19106c10",
  null
  
)

export default component.exports